import moment from 'moment';
import { createSelector } from 'reselect';

import { getSelectedStructure } from '@sophocles/features/sites/slices/selectedStructure/selectors';

export const cicStatusHistorySelector = state => state.entities.cicStatusHistories;

export const getCicStatusHistoriesForSelectedStructure = createSelector(
  getSelectedStructure,
  cicStatusHistorySelector,
  (site, histories) => {
    const cic_id = site.getIn(['cic', 'id'], 0);
    return histories
      .toList()
      .filter(status => status.get('cic', -1) == cic_id)
      .map(status => status.set('receive_time', moment(status.get('receive_time', null))));
  },
);
